<!-- Translated: skip -->
<template>
  <div class="component">

    <div v-for="(person, index) in people">

      <div class="blue-bar">
        <div class="inner">
          <span class="name">{{person.name}}:</span>
          <span class="package">
            <b v-if="person.type === 'package'">{{categories[person.subCategory] || categories[person.category]}}, paket</b>
            <b v-if="person.type === 'single'">{{categories[person.subCategory] || categories[person.category]}}:</b> {{ages[person.age]}}
          </span>
          <span class="level">
            <span v-if="person.searchPackage === 'beginner'"><b>Nivå:</b> Nybörjare</span>
            <span v-if="person.searchPackage === 'intermediate'"><b>Nivå:</b> Medelgod</span>
            <span v-if="person.searchPackage === 'advanced'"><b>Nivå:</b> Avancerad</span>
          </span>
          <span class="date right">
            <span><b>Datum:</b> {{dateRange(person)}}</span>
          </span>
        </div>
      </div>

      <div class="inner-width">

        <div class="flex">
          <div class="control">
            <div class="label">Längd (cm)</div>
            {{person.lengthCm}}
          </div>

          <div class="control">
            <div class="label">Vikt (kg)</div>
            {{person.weight}}
          </div>

          <div class="control">
            <div class="label">Skostorlek</div>
            {{person.shoeSize}}
          </div>

          <div class="control">
            <div v-if="wish" v-for="(wish, key) in person.wishes">{{wishesLabels[key]}}</div>
          </div>
        </div>

      </div>

      <div class="addon--inner-width">


        <div class="addons inner-width">

          <div class="products">
            <table>
              <tr v-for="(product, iindex) in person.products">
                <td>
                  {{product.name}}
                </td>
                <td class="price" v-if="product && product.price">
                  <b>{{product.price | currency}}</b>
                </td>
              </tr>
              <tr v-for="(product, iindex) in person.addons">
                <td>
                  {{product.name}}
                </td>
                <td class="price" v-if="product && product.price">
                  <b>{{product.price | currency}}</b>
                </td>
              </tr>
              <tr class="total">
                <td>
                  Pris åkare {{index + 1}}
                </td>
                <td class="price">
                  <b>{{
                    (
                    person.products.reduce(function(a, product) {
                      return a + product.price
                    }, 0)
                    +
                    person.addons.reduce(function(a, product) {
                      return a + product.price
                    }, 0)
                    ) | currency
                  }}</b>
                </td>
              </tr>
            </table>
          </div>

          <div style="clear:both;"></div>

        </div>

      </div>

    </div>

    <div class="sum-bar">
      <div class="inner" style="text-align:right;">
        Totalt:
        <b>
          {{
            sum | currency
          }}
        </b>
      </div>
    </div>

    <!--<button @click="addToCart()">Bekräfta</button>-->

  </div>
</template>

<script>
import { mapMutations } from 'vuex';
import API from '@/classes/API';

import moment from 'moment';

export default {
  data() {
    return {
      nextIndex: 0,
      currentIndex: 0,
      person: {},
      ages: {
        children: 'Barn',
        youths: 'Ungdom',
        adults: 'Vuxen',
      },
      categories: {},
      validStartDates: [],
      allAddons: [],
    };
  },
  components: {
  },
  async mounted() {
    const { meta } = await API.get(`/skiletting/search?age=type=${this.selectedType}&level=${this.selectedLevel}&category=${this.selectedCategory}&addon=1`);
    this.categories = meta.categories_all;
  },
  computed: {
    people() {
      return this.$store.state.cart.rentals;
    },
    sum() {
      /* eslint-disable */
      return this.people.reduce((a, person) => {
        return a + person.products.reduce((b, product) => {
          return b + product.price;
        }, 0) + person.addons.reduce((b, product) => {
          return b + product.price;
        }, 0);
      }, 0);
    },
    steps() {
      const steps = [];
      const $this = this;
      this.$store.state.cart.rentals.forEach((person, index) => {
        const no = index + 1;
        const p = {
          title: (person.name || `Åkare ${no}`),
          complete: 0,
        };
        if (person.guideCompleted) {
          p.complete = 2;
        }
        if ($this.currentIndex === index) {
          p.complete = 1;
        }
        steps.push(p);
      });
      steps.push({
        title: 'Bekräfta',
        complete: 0,
      });
      return steps;
    },
    wishesLabels() {
      return {
        wideCalf: 'Bred vad',
        wideFoot: 'Bred fot',
        softShoes: 'Mjuka pjäxor',
        hardShoes: 'Hårda pjäxor',
        shortTurn: 'Kortsväng',
        longTurn: 'Långsväng',
        preferedFootLeft: 'Vänster fram',
        preferedFootRight: 'Höger fram',
        freeText: 'Eget önskemål',
      };
    },
  },
  methods: {
    ...mapMutations([
      'openModal',
      'confirmRental',
      'completeGuides',
      'addRentalAddon',
      'addRentalPeople',
      'confirmRentals',
    ]),
    dateRange(person) {
      const start = moment(person.startDate).format('D MMMM');
      const end = moment(person.startDate).add((person.days - 1), 'days').format('D MMMM');
      return `${start} - ${end}`;
    },
    /* addToCart() {
      this.confirmRentals();
    }, */
  },
};
</script>

<style scoped lang="stylus">
@import '~@/global.styl'
</style>



// WEBPACK FOOTER //
// SkiRentalConfirm.vue?3596a1d1